module.exports = __webpack_public_path__ + "img/us_building.e7b3cd12.jpg";